import { useState } from "react";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import ListBanquesToPayement from "../../../../../../models/ListBanquesToPayement";
import withLoader from "../../../../../../components/layouts/WithLoader";
import getCurrentUserId from "../../../../../../reduxSaga/sagas/requests/currentUserId";
import PayementRHService from "../../../../../../services/RHService/PayementRHService";


const PayementAvanceSalaireEspeceFN = ({ startLoading, stopLoading }) => {
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [amount, setAmount] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
    const changeAmount = (event) => {
      setAmount(event.target.value);
    };
  const payerBill = (e) => {
    if (amount === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : le montant est vide ");
    } else if (localStorage.getItem("banqueAccount") == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Merci de choisir un compte bancaire ");
    } else {
      let payementModel = {
        idUser: getCurrentUserId(),
        banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
        idEmploye: parseInt(localStorage.getItem("IdEmployeRH")),
        typePayement: 0,
        idSalary:parseInt(localStorage.getItem("IdSalary")),
        month: localStorage.getItem("monthRH"),
        year: localStorage.getItem("yearRH"),
        ammountPayed: amount,
        urlFile: "any",
        isAvanceOrTotalPayement: 0,
      };

      startLoading();
          PayementRHService.payEmployeSalaryTotalOrAvance(payementModel)
            .then((response) => {
              console.log(response);
              if (response.data["error"]) {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur :  " + response.data["error"]);
              } else {
                setOpenSuccessAlert(true);
                setSuccessAlertText("Enregistrement avec succées");
                setTimeout(() => {
                  window.location.reload();
                }, 2000);
              }
            })
            .catch((error) => {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur :  " + error);
            })
            .finally(() => {
              stopLoading();
            });
  
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <label>Payement En espèce </label>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <label>Montant : <span style={{color:"red"}}>Max: {localStorage.getItem("restToPay")} DNT</span></label>
          <input
            type="number"
            min="0"
            step="0.1"
            max={localStorage.getItem("restToPay")}
            class="form-control"
            name="amount"
            value={amount}
            onChange={changeAmount}
          />
        </div>

        <div className="col-8">
          <label>Caisse </label>
          <ListBanquesToPayement type={2} />
        </div>
        <br />
        <div class="col-12">
          <button
            type="submit"
            onClick={payerBill}
            className="btn btn-dark float-right"
          >
            Payer
          </button>
        </div>
      </div>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};
export default withLoader(PayementAvanceSalaireEspeceFN);
